module.exports = __webpack_public_path__ + "static/img/img5x.6f58688.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/family/img5x.png
// module id = ClhX
// module chunks = 1